import styled from '@emotion/styled'
import Text from '../../../../components/common/Text'
import { BORDER } from '../../../../constant/colors'
import { mobile } from '../../../../utils/responsive-helper'

const Section = styled.div``

const Divider = styled.div`
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${BORDER};
  width: 100%;
  height: 1px;
  padding: 4px 0px;
`

const DescriptionText = styled(Text)`
  margin-top: 16px;

  ${mobile} {
    padding-bottom: 16px;
  }
`

type ProductDescriptionProps = {
  description: string
}

const ProductDesciptionCard = (props: ProductDescriptionProps) => {
  return (
    <Section className="product-description-card">
      <Text size={24} type="SemiBold">
        รายละเอียดสินค้า
      </Text>
      <Divider />
      <DescriptionText>{props.description}</DescriptionText>
    </Section>
  )
}

export default ProductDesciptionCard
